import type { HTMLAttributes } from "react";
import cx from "classnames";
import Link from "next/link";

export type ButtonVariant = "filled" | "muted" | "link";
export type ButtonState = "primary" | "error";

export type ButtonProps = HTMLAttributes<HTMLButtonElement> & {
    state?: ButtonState;
    variant?: ButtonVariant;
};

export default function Button({
    children,
    state = "primary",
    variant = "filled",
    disabled = false,
    fill = false,
    className,
    onClick,
    ...rest
}: ButtonProps) {
    let C = "button";
    if (rest.href) {
        C = Link;
    }

    return (
        <C
            type="button"
            {...rest}
            onClick={disabled ? undefined : onClick}
            className={cx(
                !fill && "inline-flex",
                fill && "w-full flex",
                buttonStyles[state]?.[variant],
                "box-border items-center justify-center rounded-md px-5 py-3 text-base font-semibold focus-within:outline focus-within:outline-2 disabled:!text-neutral-70 disabled:!bg-neutral-30",
                className,
            )}
            disabled={disabled}>
            {children}
        </C>
    );
}

const buttonStyles = {
    primary: {
        filled: "text-white bg-primary-100 hover:bg-primary-120 active:bg-primary-140 focus-within:outline-green-100",
        muted: "text-primary-100 bg-primary-10 hover:bg-primary-30 active:bg-primary-10 focus-within:bg-primary-10 focus-within:outline-green-100",
        link: "text-primary-100 bg-transparent hover:bg-primary-10 active:bg-primary-10 focus-within:bg-primary-10 focus-within:outline-green-100",
    },
    error: {
        filled: "text-white bg-red-100 hover:bg-red-120 active:bg-red-140 focus-within:outline-green-100",
        muted: "text-red-100 bg-red-10 hover:bg-red-30 active:bg-red-10 focus-within:bg-red-10 focus-within:outline-green-100",
        link: "text-red-100 bg-transparent hover:bg-red-10 active:bg-red-10 focus-within:bg-red-10 focus-within:outline-green-100",
    },
};
